import { useEffect, useState } from 'react';
import CommonSuccessNotification from 'app/ui/components/common-success-notification/CommonSuccessNotification';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'app/store/rootReducer';
import { getMessageByType } from '../config';
import { cleanFlashMessage } from 'app/store/ui';

export default function FlashMessage() {
  const [isVisible, setIsVisible] = useState<number>(0);
  const [message, setMessage] = useState<string>('');

  const { flashMessage } = useSelector((state: RootState) => state.ui);

  const dispatch = useDispatch();
  useEffect(() => {
    if (flashMessage) {
      setMessage(getMessageByType(flashMessage));
      setIsVisible(new Date().getTime());
      dispatch(cleanFlashMessage());
    }
  }, [flashMessage]);

  return <CommonSuccessNotification isOpened={isVisible} mainText={message} />;
}
